import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DownloadRota, LayoutResultadoService } from './layout-resultado.service';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { LocalizacaoService } from '../../services';
import { TipoSimulacao } from '../../enums/simulation-type.enum';

@Component({
  selector: 'app-layout-resultado',
  standalone: true,
  imports: [RouterModule, NgIf, NgFor, CommonModule],
  templateUrl: './layout-resultado.component.html',
  styleUrl: './layout-resultado.component.scss'
})
export class LayoutResultadoComponent {
  urlBase = `${environment.apiUrl}`;

  tituloResultado: string = '';
  corBordaTitulo: string = '';
  corTextoTitulo: string = '';
  editavel: boolean = false;

  rotaIndicadoresLocais: string = '';

  redeSelecionada: string = '';
  pais: string = '';
  estado: string = '';

  cidade: string = '';
  ano: string = '';

  rotaFiltroLocalidade: string = '';

  rotaDownloadResultado: string = '';

  rotaEdicaoSimulacao: string = '';

  rotaApresentacao: string = '';

  textoComoCitar: string = '';

  imagemFundo: string = 'assets/ilustrations/bridge-mountain.svg';

  corTextoRodape = '';
  corBotaoRodape = '';
  corBordaBotaoRodape = '';

  downloads: DownloadRota[] = [];

  constructor(
    private router: Router,
    public layoutResultadoService: LayoutResultadoService,
    public localizacaoService: LocalizacaoService
  ) {

    layoutResultadoService.getTitulo().subscribe((tituloResultado) => {
      this.tituloResultado = tituloResultado;
    });
    layoutResultadoService.getCorBordaTitulo().subscribe((corBordaTitulo) => {
      this.corBordaTitulo = corBordaTitulo;
    });
    layoutResultadoService.getCorTexto().subscribe((corTextoTitulo) => {
      this.corTextoTitulo = corTextoTitulo;
    });
    layoutResultadoService.getEditavel().subscribe((editavel) => {
      this.editavel = editavel;
    });

    layoutResultadoService.getRotaIndicadoresLocais().subscribe((rotaIndicadoresLocais) => {
      this.rotaIndicadoresLocais = rotaIndicadoresLocais;
    });

    layoutResultadoService.getRedeSelecionada().subscribe((redeSelecionada) => {
      this.redeSelecionada = redeSelecionada;
    });
    layoutResultadoService.getPais().subscribe((pais) => {
      this.pais = pais;
    });
    layoutResultadoService.getEstado().subscribe((estado) => {
      this.estado = estado;
    });

    layoutResultadoService.getCidade().subscribe((cidade) => {
      this.cidade = cidade;
    });
    layoutResultadoService.getAno().subscribe((ano) => {
      this.ano = ano;
    });

    layoutResultadoService.getRotaFiltroLocalidade().subscribe((rotaFiltroLocalidade) => {
      this.rotaFiltroLocalidade = rotaFiltroLocalidade;
    });

    layoutResultadoService.getRotaDownloadResultado().subscribe((rotaDownloadResultado) => {
      this.rotaDownloadResultado = rotaDownloadResultado;
    });

    layoutResultadoService.getRotaEdicaoSimulacao().subscribe((rotaEdicaoSimulacao) => {
      this.rotaEdicaoSimulacao = rotaEdicaoSimulacao;
    });

    layoutResultadoService.getRotaApresentacao().subscribe((rotaApresentacao) => {
      this.rotaApresentacao = rotaApresentacao;
    });

    this.layoutResultadoService.getDownloads().subscribe((downloads) => {
      this.downloads = downloads;
    });

    this.layoutResultadoService.getDownloads().subscribe((downloads) => {
      this.downloads = downloads;
    });

    this.layoutResultadoService.getTextoComoCitar().subscribe((textoComoCitar) => {
      this.textoComoCitar = textoComoCitar;
    });

    this.layoutResultadoService.getImagemFundo().subscribe((imagemFundo) => {
      this.imagemFundo = imagemFundo;
    });

    this.layoutResultadoService.getCorTextoRodape().subscribe((corTexto) => {
      this.corTextoRodape = corTexto;
    });

    this.layoutResultadoService.getCorBotaoRodape().subscribe((corBotao) => {
      this.corBotaoRodape = corBotao;
    });

    this.layoutResultadoService.getCorBordaBotaoRodape().subscribe((corBordaBotaoRodape) => {
      this.corBordaBotaoRodape = corBordaBotaoRodape;
    });

    const localizacaoSelecionada = this.localizacaoService.obterLocalizacaoSelecionada();

    const tipo = localizacaoSelecionada?.tipoSimulacaoSelecionado;

    // Configurando ilutração na barra lateral baseada na localização selecionada
    if (tipo === TipoSimulacao.planejamentoNacional) {
      this.layoutResultadoService.setImagemFundo('assets/ilustrations/Maps/Estado=BR, Size=MD, Stroke=True.svg');
    } else if (localizacaoSelecionada?.estadoSelecionado && !localizacaoSelecionada?.cidadeSelecionada) {
      // Estado selecionado
      const siglaEstado = localizacaoSelecionada.estadoSelecionado.sigla;
      this.layoutResultadoService.setImagemFundo(`assets/ilustrations/Maps/Estado=${siglaEstado}, Size=MD, Stroke=True.svg`);
    } else if (localizacaoSelecionada?.cidadeSelecionada) {
      // Município selecionado
      const siglaEstado = localizacaoSelecionada.estadoSelecionado?.sigla || 'BR';
      this.layoutResultadoService.setImagemFundo(`assets/ilustrations/Municípios/Estado=${siglaEstado}, Size=MD.svg`);
    } else {
      this.layoutResultadoService.setImagemFundo('assets/ilustrations/bridge-mountain.svg');
    }

  }

  abrirEdicaoSimulacao() {
    this.router.navigate([this.rotaEdicaoSimulacao]);
  }

  async copiarParaAreaDeTransferencia() {

    try {
      await navigator.clipboard.writeText(this.textoComoCitar);
    } catch (err) {
      console.error('Falha ao copiar o texto para a área de transferência', err);
    }
  }

}

